const LOCAL_STORAGE_KEY = "tomodoro.localSettings";
const SAVE_LOCAL_SETTINGS = "SAVE_LOCAL_SETTINGS";
const SAVE_LOCAL_SETTINGS_SUCCESS = "SAVE_LOCAL_SETTINGS_SUCCESS";

export default {
  LOCAL_STORAGE_KEY,
  SAVE_LOCAL_SETTINGS,
  SAVE_LOCAL_SETTINGS_SUCCESS,
};



// WEBPACK FOOTER //
// ./src/redux/modules/localSettings/constants.ts